import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SubscriptionDetails from "./SubscriptionDetails";
import TransactionHistory from "./TransactionHistory";

const TABS = [
    { key: "plan", labelKey: "tabs.SubscriptionDetails", Screen: SubscriptionDetails },
    { key: "history", labelKey: "tabs.transactionHistory", Screen: TransactionHistory },
];

// One Billing screen: the plan on one tab, past payments on the other. The tab is kept in
// the URL (?view=history) so it survives a refresh and old links can point straight to it.
const BillingPage = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const active = TABS.find((tab) => tab.key === searchParams.get("view")) || TABS[0];

    const selectTab = (key) => {
        const next = new URLSearchParams(searchParams);
        if (key === TABS[0].key) next.delete("view");
        else next.set("view", key);
        // the payment-failure message belongs to the Plan tab; don't replay it on the way back
        next.delete("success");
        next.delete("error");
        setSearchParams(next, { replace: true });
    };

    return (
        <div>
            <div className="flex justify-center space-x-4 mb-6">
                {TABS.map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        onClick={() => selectTab(tab.key)}
                        aria-pressed={tab.key === active.key}
                        className={`px-4 py-2 font-medium text-sm rounded-lg transition-colors ${tab.key === active.key
                            ? "bg-indigo-600 text-white shadow-md"
                            : "bg-white text-gray-600 hover:bg-gray-100"
                            }`}
                    >
                        {t(tab.labelKey)}
                    </button>
                ))}
            </div>
            <active.Screen />
        </div>
    );
};

export default BillingPage;
